"use client";

import { cn } from "@/utils";
import Image, { StaticImageData } from "next/image";
import { useEffect, useRef, useState } from "react";

const InfiniteMovingImgCards = ({
  items,
  direction = "left",
  speed = "fast",
  pauseOnHover = true,
  className,
}: {
  items: StaticImageData[];
  direction?: "left" | "right";
  speed?: "fast" | "normal" | "slow";
  pauseOnHover?: boolean;
  className?: string;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [start, setStart] = useState(false);

  const ordered =
    direction === "left"
      ? items
      : [
          ...items.slice(items.length >> 1),
          ...items.slice(0, items.length >> 1),
        ];

  function addAnimation() {
    if (containerRef.current && scrollerRef.current) {
      const scrollerContent = Array.from(scrollerRef.current.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        if (scrollerRef.current) {
          scrollerRef.current.appendChild(duplicatedItem);
        }
      });

      getDirection();
      getSpeed();
      setStart(true);
    }
  }

  const getDirection = () => {
    if (containerRef.current) {
      if (direction === "left") {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "forwards",
        );
      } else {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "reverse",
        );
      }
    }
  };

  const getSpeed = () => {
    if (containerRef.current) {
      if (speed === "fast") {
        containerRef.current.style.setProperty("--animation-duration", "10s");
      } else if (speed === "normal") {
        containerRef.current.style.setProperty("--animation-duration", "40s");
      } else {
        containerRef.current.style.setProperty("--animation-duration", "80s");
      }
    }
  };

  useEffect(() => {
    addAnimation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={containerRef}
      className={cn(
        "scroller mt-6 md:mt-8 mx-auto relative max-w-5xl overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_30%,white_70%,transparent)]",
        className || "",
      )}
    >
      <div
        ref={scrollerRef}
        className={cn(
          "flex min-w-full shrink-0 gap-3 py-1 flex-nowrap",
          start ? "animate-scroll" : "",
          pauseOnHover ? "hover:[animation-play-state:paused]" : "",
        )}
      >
        {ordered.map((item, idx) => (
          <Image
            key={idx}
            width={64}
            height={64}
            src={item}
            alt={`Image of ${item}`}
            title={
              item.blurDataURL?.split("/")[
                item.blurDataURL.split("/").length - 1
              ]
            }
            className="tool-logo"
            loading="lazy"
            placeholder="blur"
          />
        ))}
      </div>
    </div>
  );
};

export default InfiniteMovingImgCards;
